<template>
	<div class="degree-linear-progression-chart">
		<table id="chart" class="charts-css line">
			<tbody>
				<tr v-for="(degree, index) in factorDegreesOrdered">
					<td :style="{'--start': tuples[index].start, '--size': tuples[index].size }">
						<span class="dot" :style="{ bottom: `calc(100%*(${tuples[index].size}))`}"></span>
						<div class="data tw-text-center">
						 <span class="font-weight-bold factor-name">{{ degree.name }}</span><br>({{ degree.rate }})
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { forEach, length, range, reverse } from 'ramda';
import currency from 'currency.js';

export default {
	name: 'DegreeLinearProgressionChart',
	props: ['factorDegreesByFactor'],
	computed: {
		tuples() {
			const listLength = length(this.factorDegreesOrdered);
			let pivot = 0;
			const tuples = [];
			const rangeAmount = currency(1 / listLength).value;
			forEach(() => {
				tuples.push({
					start: currency(pivot).value,
					size: currency(pivot).add(rangeAmount).value,
				});
				pivot = currency(pivot).add(rangeAmount).value;
			}, range(0, listLength));
			return tuples;
		},
		factorDegreesOrdered() {
			return reverse(this.factorDegreesByFactor);
		},
	},
};
</script>

<style lang="scss" scoped>
.degree-linear-progression-chart {
	#chart {
		height: 400px;
		margin: 0 auto;
		tbody tr:first-child td::before {
			background-color: transparent !important;
		}
		tbody tr td::before {
			background-color: var(--app-color-secondary) !important;
		}
		tbody tr td {
			.dot {
				display: inline-block;
				width: 15px;
				height: 15px;
				border-radius: 50%;
				background-color: var(--app-color-secondary);
				position: absolute;
				margin-bottom: -10px;
				margin-right: -5px;
			}
		}
		tbody tr:last-child td .data {
			transform: translate(-20px, -20px) !important;
		}
		.data {
			transform: translateX(-20px) !important;
			.factor-name {
				font-size: 12px;
				line-height: 12px;
				display: inline-block;
				text-align: center;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreeLinearProgressionChart.vue